module.exports = __webpack_public_path__ + "img/icon-trash-enable.f4c7243a.svg";